import { API_PROXY_BASE, API_PROXY_HEADER, API_PROXY_HEADER_VALUE } from '#shared/utils/api-proxy'
import { errorStatus } from '#shared/utils/http-error'

// Calls leads-api through the server proxy, which adds the JWT and refreshes
// it, so a 401 here means the session has ended
export function useApi () {
  const { logout } = useAuth()

  const api = async (request, options = {}) => {
    try {
      return await $fetch(request, {
        ...options,
        baseURL: API_PROXY_BASE,
        headers: {
          Accept: 'application/json, application/problem+json',
          [API_PROXY_HEADER]: API_PROXY_HEADER_VALUE,
          ...options.headers
        }
      })
    } catch (error) {
      if (errorStatus(error) === 401) {
        const { pathname, search, hash } = window.location
        return await logout({ returnTo: pathname + search + hash })
      }
      throw error
    }
  }

  return { api }
}
